import { Box, Card, Spinner } from '@factorialco/deprecated-design-system'

export const LoadingState = () => {
  return (
    <Box height="s400" width="full">
      <Card>
        <Card.Content>
          <Box alignSelf="center" flexDirection="column">
            <Box paddingTop="s140">
              <Spinner />
            </Box>
          </Box>
        </Card.Content>
      </Card>
    </Box>
  )
}
